import { render, staticRenderFns } from "./PopupChangeGroupDelivery.vue?vue&type=template&id=edf76d3a&"
import script from "./PopupChangeGroupDelivery.vue?vue&type=script&lang=js&"
export * from "./PopupChangeGroupDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports